module.exports = __webpack_public_path__ + "img/bg_line_page.53bec187.png";